module.exports = __webpack_public_path__ + "static/media/Accept.00b0635e.png";